import { AxiosError } from "axios";

import api from "services/api";
import { routers_constants } from "services/constants";
import { returnResponse } from "services/utils";

type IHearingTranscriptionParams = {
  id?: number;
  guid: string;
  hearingFileId: number;
  userId: number;
  customerTemplateId: number;
  title: string;
  autoTranscription: boolean;
  createIn?: string;
  updateIn?: string;
  sendEmail: boolean;
  active: boolean;
  device: string;
  ip: string | number;
  logPoliceUnitId: number;
  logUserId: number;
};

interface IResponse {
  data: any | number | string | Array<any>;
  success: boolean;
}

export type IHearingTranscription = {
  addTranscription: (params: IHearingTranscriptionParams) => Promise<IResponse>;
  getAllByHearingFileId: (hearingFileId: number) => Promise<IResponse>;
};

export const hearingTranscriptions = {
  GetAllByHearingId: async (hearingId: number) => {
    try {
      const { data } = await api.get<any>(
        `/v1/HearingTranscription/GetAllByHearingId?hearingId=${hearingId}`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }
    }
  },
  deleteHearingTranscriptionById: async (id: number): Promise<any> => {
    try {
      const { data } = await api.delete<any>(
        `/v1/HearingTranscription/Delete?id=${id}`,
      );

      return {
        success: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          success: false,
          message: message ? message : "Error",
          data,
        };
      }
    }
  },
};

export const hearingTranscriptionsV2: IHearingTranscription = {
  addTranscription: async (params: IHearingTranscriptionParams) => {
    try {
      const { data } = await api.post(
        routers_constants.hearingTranscription.createTranscription,
        params,
      );

      return {
        data: data.data,
        success: true,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data,
        success: false,
      };
    }
  },
  getAllByHearingFileId: async (hearingFileId: number) => {
    try {
      const { data } = await api.get(
        routers_constants.hearingTranscription.getAllByHearingFileId(
          hearingFileId,
        ),
      );

      return {
        data: data.data,
        success: true,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data,
        success: false,
      };
    }
  },
};
